module.exports = __webpack_public_path__ + "media/images/wines/syrah/bottle-fac2e7a4942ab9c13344b7340136a763.png";